export const UPDATE_SCHEDULE_LOGS_API = "/api/v1/schedule/logs";
export const VIEW_CALENDAR_LOGS_API = "/api/v1/blocked_slots/logs";
export const MY_VACATIONS_LOGS_API = "/api/v1/vacation/logs";
export const BULK_RESCHEDULE_LOGS_API =
  "/api/v1/appointments/reschedule/bulk/logs";

export const DELAY_LOGS = "api/v1/delay/logs";

// role_name filter api
